export default __webpack_public_path__ + "images/J1.27b6cba.png";